import React from 'react';
import styled from '@emotion/styled';
import PlainTooltip from 'ui/elements/Tooltip/PlainTooltip';
import Avatar from 'ui/elements/avatars/Avatar';
import { halfSpacing } from 'ui/theme/themeConstants';
import { bluePlanetTheme } from 'ui/theme';
import { TooltipProps } from '@mui/material/Tooltip';

interface UserTooltipProps {
  user: {
    cwUserId: string;
    name?: string;
    position?: string;
    employer?: string;
    imageUrl?: string;
  };
  children: TooltipProps['children'];
  placement?: TooltipProps['placement'];
}

const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${halfSpacing};
  padding: ${halfSpacing};
  min-width: 200px;
`;

const UserInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

const UserName = styled.div`
  font-weight: ${bluePlanetTheme.typography.fontWeightMedium};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const UserRole = styled.div`
  font-size: ${bluePlanetTheme.typography.body2.fontSize};
  color: ${bluePlanetTheme.bluePlanetPalette.grey.main};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default function UserTooltip({ user, children, placement = 'top' }: UserTooltipProps) {
  const tooltipContent = (
    <TooltipContent onClick={e => e.stopPropagation()}>
      <Avatar size={60} imageUrl={user.imageUrl} userName={user.name} />
      <UserInfo>
        <UserName>{user.name}</UserName>
        {(user.position || user.employer) && (
          <UserRole>
            {user.position}
            {user.position && user.employer && ' at '}
            {user.employer}
          </UserRole>
        )}
      </UserInfo>
    </TooltipContent>
  );

  return (
    <PlainTooltip title={tooltipContent} placement={placement} enterDelay={300}>
      {children}
    </PlainTooltip>
  );
}
